import { DefaultContext } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
export interface ZGGraphSwitchContext extends DefaultContext {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    headers: Record<string, any>;
}
export const TARGET_DEV_HEADER = 'x-use-dev-environment';
export const createZGGraphSwitcherLink = () =>
    setContext((_, { useDevEnvironment, headers }) => {
        const newHeaders = {
            ...headers,
        };
        if (useDevEnvironment) {
            newHeaders[TARGET_DEV_HEADER] = useDevEnvironment;
        }
        return {
            headers: newHeaders,
        };
    });
